import React, { useEffect, useState } from "react";
import "./css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const visaRequirementData = [
  {
    countryName: "GERMANY",
    countryShort: "Germany",
    overview: "",
    stepDescription: [
      "A valid passport that is valid for at least six months beyond the period of your stay in the US",
      "Acceptance at a SEVP approved school and your Form I-20",
      "Application fee payment for the SEVIS",
      "Non-immigrant visa application and the Form DS-160 confirmation page",
      "Your photograph and number",
      "Transcripts, diplomas, degrees or certificates as proof of your education.",
      "Proof of funds, you are required to prove that you have sufficient funds to maintain your living expenses throughout the period of your stay in the US.",
      "Evidence that you will leave the US once you have completed your course of study. This can be in the form of an air ticket out of the US to your home country",
      "You may also have to appear for a personal interview at the US embassy or consulate.",
    ],
    duration: "2s",
    delay: "0.5s",
  },
  {
    countryName: "U.S.A.",
    countryShort: "U.S.A.",
    overview: "",
    stepDescription: [
      "A valid passport that is valid for at least six months beyond the period of your stay in the US",
      "Acceptance at a SEVP approved school and your Form I-20",
      "Application fee payment for the SEVIS",
      "Non-immigrant visa application and the Form DS-160 confirmation page",
      "Your photograph and number",
      "Transcripts, diplomas, degrees or certificates as proof of your education.",
      "Proof of funds, you are required to prove that you have sufficient funds to maintain your living expenses throughout the period of your stay in the US.",
      "Evidence that you will leave the US once you have completed your course of study. This can be in the form of an air ticket out of the US to your home country",
      "You may also have to appear for a personal interview at the US embassy or consulate.",
    ],
    duration: "2s",
    delay: "1.0s",
  },
  {
    countryName: "UNITED KINGDOM",
    countryShort: "UK",
    overview:
      "Types of Scholarships available for international students in the United Kingdom",
    stepDescription: [
      "Valid Passport",
      "First and foremost, you need to fill an application form either online or manually",
      "You need two photographs which should be taken in the last six months",
      "You need to prove that you have enough funds for studying and living in United Kingdom",
      "You will need to present a document that shows the location of your accommodation in United Kingdom",
      "You are required to submit the slip as proof that you have submitted your visa fee",
    ],
    duration: "2s",
    delay: "1.5s",
  },
  {
    countryName: "CANADA",
    countryShort: "Canada",
    overview:
      "There are three types of scholarships available for study abroad Canada",
    stepDescription: [
      "Valid Passport",
      "Attested copies of 10<sup>th</sup>, 12<sup>th</sup>, and Degree certificates",
      "Academic references - 2",
      "Employer references - 2",
      "SOP (Statement of Purpose)",
      "Certificates of extracurricular achievements",
      "An acceptance letter from your education institution",
      "Proof of payment",
      "Proof of financial funds",
      "Two Passport size photographs",
      "Study Permit and visa",
      "Proof of English Proficiency",
    ],
    duration: "2s",
    delay: "2.0s",
  },
  {
    countryName: "U.A.E",
    countryShort: "U.A.E",
    overview:
      "In Dubai, you can study on fully or partially funded scholarships. Every year, the government of Dubai and universities in Dubai award scholarships to international students and local residents, here is a compiled list of some of the best PhD Scholarships in Dubai, Masters Scholarships in Dubai, and undergraduate level scholarships.",
    stepDescription: [
      "A valid passport",
      "Four passport copies",
      "Twelve recent passport-sized photos.",
      "Degree and certificates",
      "A letter of acceptance received from a university.",
      "Proof of funds.",
      "A tenancy agreement from the University",
      "A copy of the tuition fee receipt for the current academic year.",
      "A copy of the visa fee receipt for the current academic year.",
    ],
    duration: "2s",
    delay: "2.5s",
  },
  {
    countryName: "AUSTRALIA",
    countryShort: "Australia",
    overview:
      "There is a vast variety of scholarships available for international students.",
    stepDescription: [
      "Valid Passport",
      "Receive a Confirmation of Enrollment from the education institution",
      "Meet the general temporary entrant requirement. In order to meet this requirement you will be asked to write an essay on two topics: That you are genuinely coming to Australia to study and not for any other reason and that you will only be residing in Australia temporarily",
      "You need to submit the proof of funds for paying Education fees, living expenses, and travel fairs",
      "Prove your English proficiency skills",
      "Meet health and character requirements",
      "Provide evidence of Overseas Student Health Cover",
    ],
    duration: "2s",
    delay: "3.0s",
  },
];

export default function VisaRequirement(props) {
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    countryName: "GERMANY",
    countryShort: "Germany",
    overview: "",
    stepDescription: [
      "A valid passport that is valid for at least six months beyond the period of your stay in the US",
      "Acceptance at a SEVP approved school and your Form I-20",
      "Application fee payment for the SEVIS",
      "Non-immigrant visa application and the Form DS-160 confirmation page",
      "Your photograph and number",
      "Transcripts, diplomas, degrees or certificates as proof of your education.",
      "Proof of funds, you are required to prove that you have sufficient funds to maintain your living expenses throughout the period of your stay in the US.",
      "Evidence that you will leave the US once you have completed your course of study. This can be in the form of an air ticket out of the US to your home country",
      "You may also have to appear for a personal interview at the US embassy or consulate.",
    ],
    duration: "2s",
    delay: "0.5s",
  });

  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = visaRequirementData.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(visaRequirementData[countryInfo]);
    }
  }, [props.selectedTab]);

  let delay = 0.3;
  const renderVisaRequirement = selectedCountryInfo.stepDescription.map(
    (item, index) => {
      if (selectedCountryInfo.stepDescription.length)
        return (
          <div
            className="col-lg-4 col-md-4 col-12 wow bounceIn"
            data-wow-duration="2s"
            data-wow-delay={delay + 0.2 + "s"}
            key={Math.random()}
          >
            <div className="vr-steps">
              <div className="univ-count">{index + 1}</div>
              <div className="vr-step-desc">
                <div
                  dangerouslySetInnerHTML={{
                    __html: item,
                  }}
                ></div>
              </div>
            </div>
          </div>
        );
    }
  );

  return (
    <div className="vs-requirement-wrapper visa_under_main_container">
      <div className="container-lg">
        <div
          className="title bottom-line wow bounceIn"
          data-wow-delay="0.5s"
          data-wow-duration="2s"
        >
          <span>
            {selectedCountryInfo.stepDescription.length} Steps for Visa
            Requirement
          </span>
        </div>
        <div className="vr-step-wrapper">
          <div className="row">{renderVisaRequirement}</div>
        </div>
      </div>
    </div>
  );
}
